import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
declare var $: any;
@Injectable({
  providedIn: 'root',
})

export class Utility {
  constructor(private datePipe: DatePipe) {
  }


  dateFormate(date: Date) {
    return this.datePipe.transform(date, "MM/dd/yyyy");
  }



  isEmpty(obj) {
    for (let prop in obj) {
      if (obj.hasOwnProperty(prop))
        return false;
    }
    return true;
  }


  isMobileDevice() {
    //let checkDevice = /(android)/i.test(navigator.userAgent); 
    let checkDevice = (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));
    if (checkDevice) {
      return true;
    }

  };
  formatNumber(num) {
    if (isNaN(num) || num == null || num == undefined) {
      return '$0.00';
    } else {
      return `$${num.toFixed(2)}`;
      //return `$${num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`;
    }
  }
  FormatNumberWoCurrency(num) {
    if (isNaN(num) || num == null || num == undefined) {
      return '0.00';
    } else {
      return num.toFixed(2);
      //return `${num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`;
    }
  }
}
